import Box from '@mui/material/Box'
import { observer } from 'mobx-react-lite'
import { themeConfig }from '@gap/shared/theme'

interface GapDialogSidebarWrapperProps {
   sidebar?: React.ReactNode, children: React.ReactNode
}

export default observer(function GapDialogSidebarWrapper(props: GapDialogSidebarWrapperProps) {
   if (!props.sidebar) {
      return props.children
   }

   return <Box sx={{ display: 'flex', height: '100%' }} data-testid="message-dialog-sidebar">
      <Box sx={{ width: '264px', p: 2, borderRight: `1px solid ${themeConfig.primary[200]}` }}>
         {props.sidebar}
      </Box>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
         {props.children}
      </Box>
   </Box>
})
